import { render, staticRenderFns } from "./MainAboutUs.vue?vue&type=template&id=5eb648fb&scoped=true&"
import script from "./MainAboutUs.vue?vue&type=script&lang=js&"
export * from "./MainAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./MainAboutUs.vue?vue&type=style&index=0&id=5eb648fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb648fb",
  null
  
)

export default component.exports